export const _t = (key) => {
  try {
    let k = key.toString().trim();
    return i18n && typeof i18n[k] !== 'undefined' ? i18n[k] : key;
  } catch { return key; }
}

const TranslationService = {
  defaultLang: 'sq',
  languages: [
    { key: 'sq', name: 'Albanian' },
    { key: 'en', name: 'English' },
    { key: 'it', name: 'Italian' },
    { key: 'mk', name: 'Macedonian' },
    { key: 'de', name: 'German' }
  ],
  _t: (key) => {
    return _t(key);
  },
  setLanguage: (lang) => {
    localStorage.setItem('lang', lang);
    window.location.reload();
  },
  loadTranslations: async () =>  {
    return new Promise((resolve, reject) => {
      if(i18n) {
        resolve();
        return;
      }
      
      let lang = localStorage.getItem('lang');
      if(!lang || lang === null || !TranslationService.languages.some( l => l.key === lang)) {
        lang = TranslationService.defaultLang;
        localStorage.setItem('lang', lang);
      }

      $.getJSON(`./i18n/${lang}.json?v=30`, (json) => {
        i18n = json;
        resolve()
      }, function() {
        reject();
      });
    });
  },
  translateStatics: async () => {
    $('*[translate]').text((i, text) => {
      return TranslationService._t(text);
    });
  }
}

export default TranslationService;